import memoizeOne from 'memoize-one';

import { EditorCardProvider } from '@atlaskit/editor-card-provider';

import { InlineCommentEditorCardProvider } from '@confluence/comments-util/entry-points/classes';

export const getSmartCardOptions = memoizeOne((enableChromelessEditorCardProvider: boolean) => {
	/**
	 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
	 * (only supports Cloud single-issue URLs right now)
	 */
	const smartLinksBeforeMacros =
		'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(
			',',
		);

	const cardProvider = Promise.resolve(
		enableChromelessEditorCardProvider
			? new InlineCommentEditorCardProvider(undefined, undefined, 'CONFLUENCE')
			: new EditorCardProvider(undefined, undefined, 'CONFLUENCE'),
	);

	return {
		provider: cardProvider,
		resolveBeforeMacros: smartLinksBeforeMacros,
		allowBlockCards: true,
		allowEmbeds: true,
	};
});
